import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import config from '../../config/config';

const NavBar = () => {
    const [top, setTop] = useState(!window.scrollY);
    const [isOpen, setisOpen] = React.useState(false);
    const location = useLocation();

    const lightLogo = config.lightLogo;
    const darkLogo = config.darkLogo;

    function handleClick() {
        setisOpen(!isOpen);
    }

    useEffect(() => {
        const isSpecialRoute = location.pathname === '/contact'
            || location.pathname === '/get-demo'
            || location.pathname === '/info'
            || location.pathname === '/about'
            || location.pathname === '/app'
            || location.pathname.startsWith('/news');

        if (isSpecialRoute) {
            setTop(false);
            return;
        }

        let ticking = false;
        const scrollHandler = () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                setTop(window.pageYOffset <= 10);
                ticking = false;
            });
        };

        scrollHandler();
        window.addEventListener('scroll', scrollHandler, { passive: true });
        return () => window.removeEventListener('scroll', scrollHandler);
    }, [location]);

    const isSpecialRoute = location.pathname === '/contact'
        || location.pathname === '/get-demo'
        || location.pathname === '/about'
        || location.pathname === '/app'
        || location.pathname.startsWith('/news')
        || (location.pathname === '/get-demo' && location.hash === '#demo');

    const getLogo = () => {
        if ((isSpecialRoute && top) || (!isSpecialRoute && top)) {
            return darkLogo;
        }
        return lightLogo;
    };

    const getTextColorClass = () => {
        if ((isSpecialRoute && top) || (!isSpecialRoute && top)) {
            return 'text-blue-900';
        }
        return 'text-white';
    };

    return (
        <nav
            className={`fixed top-0 w-full z-50 transition duration-300 ease-in-out mb-16 ${!top && 'bg-white shadow-lg'}`}
            style={{
                // 内联样式保护，确保不受全局 CSS 影响
                transform: 'none',
                WebkitTransform: 'none',
                backfaceVisibility: 'visible'
            }}
        >
            <div className="flex flex-row justify-between items-center py-2">
                <div className="flex flex-row justify-center md:px-12 md:mx-12 items-center text-center font-semibold">
                    <HashLink smooth to="/#hero" className="flex items-center">
                        <img
                            src={getLogo()}
                            alt="江西族迹"
                            className="h-10 md:h-12 transition-opacity duration-300"
                        />
                    </HashLink>
                </div>
                <div className="group flex flex-col items-center">
                    <button
                        className={`p-2 rounded-lg lg:hidden transition-colors duration-300 ${getTextColorClass()}`}
                        onClick={handleClick}
                    >
                        <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                            {isOpen && (
                                <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                            )}
                            {!isOpen && (
                                <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                            )}
                        </svg>
                    </button>
                    <div className='hidden space-x-6 lg:inline-block p-5'>
                        <NavLinks isScrolled={!top} />
                    </div>

                    <div className={`fixed transition-transform duration-300 ease-in-out transit flex justify-center left-0 w-full h-auto rounded-md p-24 bg-white lg:hidden shadow-xl top-14 ${isOpen ? "block" : "hidden"} `}>
                        <div className='flex flex-col space-y-6'>
                            <NavLinks isScrolled={true} />
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default NavBar;